"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendPageWMDAShow = exports.sendWMDAShow = exports.sendAdvWMDAShow = exports.bindWMDAClick = exports.sendClickStatistics_wmda = exports.domClickStatistics_wmda = exports.aClickStatistics_wmda = exports.initWMDASDK = void 0;
var tools_1 = require("./tools");
var urlMethod_1 = require("./urlMethod");
var getCurPlatform = function () {
    var array = window.location.hostname.split(".");
    var hostname;
    if (array.length > 2) {
        hostname = array[array.length - 3];
    }
    else {
        hostname = "";
    }
    return hostname.indexOf("apps") == 0
        ? "app"
        : hostname.indexOf("m") == 0
            ? "m"
            : "pc";
};
/**
 *
 * @param config
 *   如果是新项目 appid/key/project_id必须存在用于覆盖已存在的配置
 *   其他的配置项可以参照wmda官方提供文档
 * @param type
 * @returns
 */
var initWMDASDK = function (opt) {
    if (opt === void 0) { opt = { config: {} }; }
    if (typeof opt.type == "undefined" && typeof window != "undefined") {
        opt.type = getCurPlatform();
    }
    return new Promise(function (resolve, reject) {
        if (typeof window !== "undefined") {
            // 默认有两种埋点配置 xinchePC首页 和 xincheM的配置项
            // 如果是新的项目请重新传config配置 覆盖或者添加
            var defaultConfig = {
                pc: {
                    appid: 3446131686530,
                    key: "w0zko77g",
                    project_id: "3446067166722",
                    cookie_domain: "58che.com"
                },
                m: {
                    appid: 7879228080305,
                    key: "4gdjv7js",
                    project_id: "3446309215618",
                    cookie_domain: ""
                },
                app: {
                    appid: 7384444133559,
                    key: "2f6hhcyx",
                    project_id: "7383839969589",
                    cookie_domain: ""
                }
            };
            // 初始化WMDA的sdk配置，必须在引入js之前初始化
            if (typeof window.WMDA_SDK_CONFIG == "undefined") {
                window.WMDA_SDK_CONFIG = __assign(__assign({ api_v: 1, sdk_v: 0.1, mode: "report" }, defaultConfig[opt.type]), opt.config);
            }
            if (typeof window.WMDA_SDK == "undefined" && !(typeof window.tplWmda != 'undefined' && window.tplWmda == 1)) {
                // pc端旧页面模板上直接引入了statistic js文件，为避免多次引入 顾在已经引入statistic.js文件的页面上打入window.tplWmda=1，通过这样来避免再次引入
                // 采用缓存10天的方式对js进行缓存刷新
                // 官方推荐后续跟版本号但是版本号需要后台提供so不采用，
                var n = 10;
                tools_1.loadScript({
                    url: "//j1.58cdn.com.cn/wmda/js/statistic.js?" + parseInt((+new Date() / (86400000 * n)).toString())
                }).then(function () {
                    resolve(true);
                }, function () {
                    reject();
                });
            }
            else {
                resolve(true);
            }
        }
    });
};
exports.initWMDASDK = initWMDASDK;
/**
 * 监听a标签触发wmda埋点
 * @param {string} from pc/m/app  默认为pc
 * data-wmda-eventid 必须存在
 */
var aClickStatistics_wmda = function () {
    if (typeof window.WMDA_SDK !== "undefined" &&
        typeof document !== "undefined" &&
        !window.aClickStatistics_wmda_flag) {
        window.aClickStatistics_wmda_flag = true;
        tools_1.live(document, "a", "click", function (dom) {
            exports.bindWMDAClick(dom);
        });
    }
};
exports.aClickStatistics_wmda = aClickStatistics_wmda;
/**
 * 监听指定的dom触发wmda埋点，
 * 必须条件
 *    classname必须是'wmda-statisic'
 *    data-wmda-eventid 属性必须存在
 * @param from
 */
var domClickStatistics_wmda = function (className) {
    if (typeof window.WMDA_SDK !== "undefined" &&
        typeof document !== "undefined") {
        tools_1.liveDom(document, className, "click", function (dom) {
            exports.bindWMDAClick(dom);
        });
    }
};
exports.domClickStatistics_wmda = domClickStatistics_wmda;
/**
 * 触发wmda埋点
 * @param eventId
 * @param otherData
 */
var sendClickStatistics_wmda = function (eventId, otherData) {
    var cityId = "";
    if (typeof window.WMDA_SDK !== "undefined" &&
        typeof document !== "undefined" &&
        eventId) {
        // getCurPlatform
        var platform = getCurPlatform();
        if (platform == "pc") {
            cityId = tools_1.getCookie("xgoSubstationId");
        }
        else {
            if (tools_1.getCookie("Xgo_GeolocationInfo")) {
                var str = tools_1.getCookie("Xgo_GeolocationInfo")
                    .split("@")
                    .filter(function (item) {
                    return item.indexOf("cityid") != -1;
                })[0];
                if (str) {
                    cityId = str.split("=")[1];
                }
            }
            else if (tools_1.getCookie("xgoJsIpCity")) {
                cityId = JSON.parse(decodeURIComponent(tools_1.getCookie("xgoJsIpCity"))).cityId;
            }
            // pc端 xgoSubstationId m端 Xgo_GeolocationInfo  xgoJsIpCity
            // Xgo_GeolocationInfo  sid=3@name=北京@url=https%3A%2F%2Fbj.58che.com%2F@provinceid=1@cityid=613@classid=29@pingyin=beijing@mUrl=%2Finfo%2Fmarket_29.html@status=1@listname=bj@listid=1@isSub=4
            // xgoJsIpCity {"provId":1,"provName":"\\u5317\\u4eac","cityId":613,"cityName":"\\u5317\\u4eac","listId":"1","listname":"bj"}
            //
        }
        var config = __assign({ event_id: eventId, cityId: cityId, from_code: tools_1.getCookie("from_code"), url: window.location.href, cateid: "4,398038", reffer: document.referrer }, otherData);
        // custom-其他埋点 可以传额外参数
        if (urlMethod_1.getUrlParam("debug") == 1) {
            console.log("wmda埋点信息：", config);
        }
        window.WMDA_REPORT("custom", __assign({}, config));
        // 平台上还有其他三种类型 但是不能传递额外的参数所以不使用
        // click-点击埋点
        // show_elem-展现埋点
        // pc - 统计埋点
    }
};
exports.sendClickStatistics_wmda = sendClickStatistics_wmda;
/**
 * 从dom上获取data-wmda- 相应的上报数据，发起点击埋点
 * @param dom
 */
var bindWMDAClick = function (dom) {
    if (!dom || typeof window == "undefined") {
        return false;
    }
    var obj = {}, eventId;
    for (var i = 0; i < dom.attributes.length; i++) {
        if (dom.attributes.item(i).name.toLocaleLowerCase() == "data-wmda-placeid" ||
            dom.attributes.item(i).name.toLocaleLowerCase() == "data-wmda-eventid") {
            eventId = dom.attributes.item(i).value;
        }
        else if (dom.attributes.item(i).name.indexOf("data-wmda") != -1 &&
            dom.attributes.item(i).value) {
            obj[dom.attributes.item(i).name.replace("data-wmda-", "")] =
                dom.attributes.item(i).value;
        }
    }
    if (Object.keys(obj).length != 0 && !eventId) {
        var errorTip = "wmda\u70B9\u51FB\u57CB\u70B9\u5931\u8D25\uFF0C\u70B9\u51FBdom\u4E0A\u7F3A\u5C11\u5C5E\u6027:\n\n                      1\u3001\u786C\u5E7F\u5E7F\u544A\u4F4D\u4E0A\u662F\u5426\u6709data-wmda-placeid?\n\n                      2\u3001\u975E\u786C\u5E7F\u5E7F\u544A\u4F4D\u7684\u70B9\u51FBdom\u4E0A\u662F\u5426\u6709data-wmda-eventid?";
        console.log(errorTip);
        if (urlMethod_1.getUrlParam("debug") == 1) {
            alert(errorTip);
        }
        return false;
    }
    else if (Object.keys(obj).length == 0) {
        return false;
    }
    if (!(obj.actiontype && obj.actiontype == 'show')) {
        obj.actiontype = "click";
    }
    exports.sendClickStatistics_wmda(eventId, obj);
};
exports.bindWMDAClick = bindWMDAClick;
/**
 * 上报硬广的展现埋点
 */
var sendAdvWMDAShow = function () {
    if (typeof window == "undefined") {
        return false;
    }
    if (typeof window.WMDA_SDK == "undefined" ||
        typeof window.wmdaShowData == "undefined") {
        // 初始化wmda未完成||window.wmdaShowData数据不存在 间隔5s查询一次
        if (window.timer_wmdaSendShow) {
            clearTimeout(window.timer_wmdaSendShow);
        }
        var pollTimes = typeof window.timer_wmdaSendShow_num == "undefined"
            ? 0
            : parseInt(window.timer_wmdaSendShow_num); // 轮询次数
        if (pollTimes >= 12) {
            return false;
        }
        window.timer_wmdaSendShow_num = pollTimes + 1;
        window.timer_wmdaSendShow = window.setTimeout(function () {
            exports.sendAdvWMDAShow();
        }, 5000);
        return false;
    }
    var obj = {
        actiontype: "show"
    };
    window.wmdaShowData.map(function (item) {
        obj.pageTypeId =
            typeof item.pageTypeId == "undefined" ? "" : item.pageTypeId;
        item.channelId && exports.sendClickStatistics_wmda(item.channelId, obj);
    });
};
exports.sendAdvWMDAShow = sendAdvWMDAShow;
exports.sendWMDAShow = exports.sendAdvWMDAShow;
var sendPageWMDAShow = function (params) {
    if (typeof window == "undefined") {
        return false;
    }
    if (typeof window.WMDA_SDK == "undefined") {
        exports.initWMDASDK().then(function () {
            exports.sendPageWMDAShow(params);
        });
        return false;
    }
    var eventid = params.eventid, otherParams = __rest(params, ["eventid"]);
    if (!eventid || !(params === null || params === void 0 ? void 0 : params.pagetype) || !(params === null || params === void 0 ? void 0 : params.page)) {
        var errorTip = "wmda\u9875\u9762\u5C55\u73B0\u57CB\u70B9\u5931\u8D25\uFF0C\u7F3A\u5C11\u4EE5\u4E0B\u5FC5\u4F20\u53C2\u6570\uFF1Aeventid\u3001pagetype\u3001page!";
        console.log(errorTip);
        if (urlMethod_1.getUrlParam("debug") == 1) {
            alert(errorTip);
        }
        return false;
    }
    var obj = __assign({ actiontype: "show" }, otherParams);
    exports.sendClickStatistics_wmda(eventid, obj);
};
exports.sendPageWMDAShow = sendPageWMDAShow;
